import { getAmountInCents } from "Utilities/Amount/getAmountInCents";
import {
  getAmountInDollarsAndCents,
  getAmountInDollarsClean,
} from "Utilities/Amount/getAmountInDollarsClean";

const getFundItAmountsInDollars = (amounts = []) =>
  amounts.map((a) => ({
    ...a,
    amount: getAmountInDollarsAndCents(a.amount),
  }));

const getFundItAmountsInCents = (amounts) =>
  amounts.map(({ amount, numberOfSlots }) => ({
    numberOfSlots,
    amount: Number(getAmountInCents(amount)),
  }));

const getFundItAmountsPerItem = (amounts) => {
  const centAmounts = getFundItAmountsInCents(amounts);
  return centAmounts.filter(({ numberOfSlots }) => numberOfSlots === null);
};

/**
 * @param {Array} amountsInDollars
 * @param {Array} amountsInCents
 */
const getTiersHaveChanged = (
  amountsInDollars = [],
  amountsInCents = [],
  isPerSlot,
  hasSignupCost
) => {
  if (!hasSignupCost) return false;

  if (isPerSlot) {
    const inDollars = amountsInDollars.find(
      ({ numberOfSlots }) => numberOfSlots === null
    );
    const inCents = amountsInCents.find(
      ({ numberOfSlots }) => numberOfSlots === null
    );
    return (
      Number(getAmountInCents(inDollars?.amount)) !== Number(inCents?.amount)
    );
  }

  return amountsInDollars.some((elem, i) => {
    return (
      Number(getAmountInCents(elem?.amount)) !==
        Number(amountsInCents?.[i]?.amount) ||
      Number(elem?.numberOfSlots) !== Number(amountsInCents?.[i]?.numberOfSlots)
    );
  });
};

export {
  getFundItAmountsInDollars,
  getFundItAmountsInCents,
  getTiersHaveChanged,
  getFundItAmountsPerItem,
};
